/**
 * View-mode identifiers and paging size for the dashboard shell.
 *
 * These were local `const X = "X"` declarations inside the Dashboard component.
 * They are lifted here because the shell and the IFAS hook both need them, and
 * duplicating twenty-five string literals across two files is how the two
 * halves drift apart.
 */
export const PAGE_COUNT = 10;

// Claims
export const CREATE_CLAIM = "CREATE_CLAIM";
export const HISTORY = "HISTORY";
export const PERSONAL_INFO = "PERSONAL_INFO";

// IFAS
export const CREATE_CASE = "CREATE_CASE";
export const CREATE_QUOTATION = "CREATE_QUOTATION";
export const ADD_DRIVER = "ADD_DRIVER";
export const ADD_VEHICLE = "ADD_VEHICLE";
export const CASE_DETAILS = "CASE_DETAILS";
export const BODY_REMOVAL = "BODY_REMOVAL";
export const QUOTATIONS_DETAILS = "QUOTATIONS_DETAILS";
export const CATERING_DETAILS = "CATERING_DETAILS";
export const TOMBSTONE_DETAILS = "TOMBSTONE_DETAILS";
export const DRIVERS_DETAILS = "DRIVERS_DETAILS";
export const VEHICLE_DETAILS = "VEHICLE_DETAILS";
export const IFAS_HOME = "IFAS_HOME";
export const FLEET = "FLEET";
export const MORTUARY = "MORTUARY";
export const MORTUARY_DETAILS = "MORTUARY_DETAILS";
export const WAREHOUSE = "WAREHOUSE";
export const BODY_DISPATCH = "BODY_DISPATCH";
export const BODY_DISPATCH_DETAILS = "BODY_DISPATCH_DETAILS";
export const FUNERAL_PLANNING = "FUNERAL_PLANNING";
export const SPECIAL_SERVICES = "SPECIAL_SERVICES";
export const MEMORIALS = "MEMORIALS";
